export default __webpack_public_path__ + "static/media/empty_top_matches.f3dd0c01.svg";